import { getI18nFromGeneral } from 'src/tools/tools';
import { handleError } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import { get } from 'lodash';

const generateContentSetting = () => {
  return {
    text: '非常抱歉，您访问的页面不存在',
    image: {
      altText: 'products',
      contentType: 'image/svg+xml',
      createdBy: 'admin',
      createdDate: '2021-04-27 10:00:00',
      deleted: false,
      fileName: 'unifyxp2/default/page404/404.svg',
      height: 81,
      modifiedBy: 'admin',
      modifiedDate: '2021-04-27 10:00:00',
      originalName: '404.svg',
      size: 1708,
      tags: [],
      url: 'https://resource2.unifyxp.com/unifyxp2/default/page404/404.svg',
      uuid: 'c0d7da8c-2b41-4e58-b5de-ecbd261c501c',
      valid: true,
      width: 81,
    },
  };
};

const generateButtonText = () => {
  return {
    text: '返回首页',
    buttonThemeUuid: null,
  };
};

const checkContentSetting = () => {
  //   const image = get(data, 'image');
  //   const title = get(data, 'title');
  const checkImage = (image) => {
    const uuid = get(image, 'uuid');
    if (!uuid) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.${999998}`),
      ]);
    }
  };
  const checkText = (title) => {
    if (!title) {
      return handleError([
        getI18nFromGeneral(`general.moduleListError.${999999}`),
      ]);
    }
  };
  const checkAll = (data) => {
    const image = get(data, 'image');
    const title = get(data, 'title');
    const iRes = checkImage(image);
    const iTitle = checkText(title);
    return {
      hasError: get(iTitle, 'hasError') || get(iRes, 'hasError'),
    };
  };
  return { checkAll, checkImage, checkText };
};

const checkButtonText = (text) => {
  if (!text) {
    return handleError([
      getI18nFromGeneral(`general.moduleListError.${999999}`),
    ]);
  }
};

const checkAll = (data) => {
  const text = get(data, 'buttonText.buttonText');
  const contentSetting = get(data, 'contentSetting');
  const { checkAll } = checkContentSetting();
  const rText = get(checkButtonText(text), 'hasError');
  const rContent = get(checkAll(contentSetting), 'hasError');
  return {
    hasError: rText || rContent,
  };
};

export {
  checkContentSetting,
  checkButtonText,
  generateContentSetting,
  generateButtonText,
  checkAll,
};
